<template>
  <div class="quest-chapter-intro">
    <div class="quest-chapter-intro__content">
      <div
        v-if="introImageUrl"
        class="quest-chapter-intro__image">
        <img :src="introImageUrl" :alt="chapterName" />
      </div>

      <div class="quest-chapter-intro__header">
        <h1 class="quest-chapter-intro__title">{{ chapterName }}</h1>
      </div>

      <div class="quest-chapter-intro__body">
        <div
          class="quest-chapter-intro__message"
          v-html="formattedIntro" />
      </div>

      <div class="quest-chapter-intro__actions">
        <button
          class="btn btn--fat"
          @click="handleStart">
          Start Chapter
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import sharedStore from "components/quest/shared-store";

export default {
  name: "QuestChapterIntro",
  data() {
    return {
      sharedStore
    }
  },
  props: {
    chapterName: {
      type: String,
      required: true
    },
    intro: {
      type: String,
      default: ""
    },
    introImageUrl: {
      type: String,
      default: null
    }
  },

  computed: {
    formattedIntro() {
      const username = this.sharedStore.state.username;

      return (this.intro || "").replaceAll("%username%", username);
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    handleKeydown(event) {
      // Check for CMD + Enter (Mac) or CTRL + Enter (Windows)
      if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
        event.preventDefault()
        event.stopPropagation()

        this.sharedStore.nextScreen();
      }
    },
    handleStart() {
      this.sharedStore.nextScreen();
    }
  }
}
</script>

<style lang="scss" scoped>
.quest-chapter-intro {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: $px48 0;

  &__content {
    max-width: 600px;
    width: 100%;
  }

  &__title {
    margin-bottom: $px32;

    @include h1;
  }

  &__image {
    margin-bottom: $px32;

    img {
      display: block;
      max-width: 100%;
      height: auto;

      border-radius: $px8;
    }
  }

  &__message {
    margin-bottom: $px48;

    @include font-regular;
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: $px16;
  }
}
</style>
